import type { UnifiedChatContentRecommendation } from '~kui/types/contentRecommendation';

type CollectionRec = Extract<UnifiedChatContentRecommendation, { type: 'learning_asset_collection' }>;

const ANYWAY_PARTNER_NAME = 'anyway';

/** Whether a partner is Anyway itself, matched on its name as the backend's sponsored filter does. */
export const isAnywayPartner = (name: string | null | undefined): boolean =>
  name?.trim().toLowerCase() === ANYWAY_PARTNER_NAME;

/** The partner a card names: the first that is not Anyway itself, else the first there is. */
export const sponsoringPartner = <T extends { name?: string | null }>(partners: readonly T[]): T | undefined =>
  partners.find(({ name }) => !isAnywayPartner(name)) ?? partners[0];

/**
 * Content partnered with Anyway itself is base (unsponsored) content — only an
 * external partner makes a collection sponsored, which keeps the default coin
 * tag instead of the Coin Rush promo variant.
 */
export const isExternallySponsored = (rec: CollectionRec): boolean =>
  !!rec.partnerLogoUrl && !isAnywayPartner(rec.partnerName);

/** Whether a card shows the Coin Rush promo: the flag is on and no external partner sponsors it. */
export const coinRushApplies = (coinRush: boolean, rec: CollectionRec): boolean =>
  coinRush && !isExternallySponsored(rec);

/**
 * Single render home for the coin pill copy/icon pairing; each card decides
 * whether the Coin Rush promo applies (its coinRush prop, gated by
 * isExternallySponsored where the card carries partner data). Reverting the
 * promo means deleting the rush branch here, not editing three card templates.
 */
export const coinPillVariant = (rush: boolean) =>
  rush
    ? { key: 'unified.common.rushCoins', coinSrc: '/images/kui/coin.webp' } as const
    : { key: 'unified.common.earnCoins', coinSrc: '/images/kui/unified/gold-coin.webp' } as const;
